import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  categories: [],
  isLoading: false,
  viewSingleCategory: {},
  isViewModalOpen: false,
  isEditModalOpen: false,
  isDeleteModalOpen: false,
  isSuccess: false,
  isError: false,
  message: "",
  response: {},
};

const api_URL = process.env.REACT_APP_CATEGORY_URL;
console.log(api_URL)
console.log(api_URL + '/user/category')
export const getCategories = createAsyncThunk(
  "categories/getCategories",
  async (_, thunkAPI) => {
    const response = await axios.get(
      api_URL + '/user/category'
    );
    console.log('User_nik', response.data);
    return response.data;
  }
);

export const addCategory = createAsyncThunk(
  "categories/addCategory",
  async (name, thunkAPI) => {
    try {
      console.log("categoryname", { name });
      const response = await axios.post(
        api_URL + '/admin/category', name,
        {
          headers: {
            Authorization: `Bearer ${name.accessToken}`,
          },
        }
      );
      console.log('admin_nik', response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const deleteCategory = createAsyncThunk(
  "categories/deleteCategory",
  async (categoryId, thunkAPI) => {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_KEY}/categories_delete`,
      { data: { id: categoryId } }
    );
    return response.data;
  }
);

export const updateCategory = createAsyncThunk(
  "categories/updateCategory",
  async (categoryDetail, thunkAPI) => {
    const response = await axios.put(
      `${process.env.REACT_APP_API_KEY}/categories_update`,
      categoryDetail
    );
    return response.data;
    // console.log(categoryDetail);
  }
);

const categorySlice = createSlice({
  name: "categories",
  initialState,
  reducers: {
    viewCategory: (state, action) => {
      state.isViewModalOpen = true;
      state.viewSingleCategory = action.payload;
    },
    openDeleteModal: (state, action) => {
      state.isDeleteModalOpen = true;
      state.viewSingleCategory = action.payload;
    },
    closeModal: (state) => {
      state.isViewModalOpen = false;
      state.isDeleteModalOpen = false;
      state.viewSingleCategory = {};
      state.isEditModalOpen = false;
    },
    editCategory: (state, action) => {
      state.isEditModalOpen = true;
      state.viewSingleCategory = action.payload;
    },
    // deleteCategory: (state, action) => {
    //   const categoryId = action.payload;
    //   state.categories = state.categories.filter(
    //     (category) => category.id !== categoryId
    //   );
    // },
  },
  extraReducers: (builder) => {
    builder.addCase(getCategories.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getCategories.fulfilled, (state, action) => {
      state.isLoading = false;
      state.categories = action.payload.result;
    });
    builder.addCase(getCategories.rejected, (state, action) => {
      state.isLoading = false;
      console.error(action.payload.response.data);
    });
    builder.addCase(addCategory.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(addCategory.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.isError = false;
      state.message = action.payload.message;
      state.response = action.payload;
    });
    builder.addCase(addCategory.rejected, (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = true;
      state.message = action.payload.message;
      state.response = action.payload;
    });
    builder.addCase(deleteCategory.pending, (state) => {
      state.isLoading = true;
      state.isDeleteModalOpen = false;
    });
    builder.addCase(deleteCategory.fulfilled, (state, action) => {
      state.isLoading = false;
      state.response = action.payload;
    });
    builder.addCase(deleteCategory.rejected, (state, action) => {
      state.isLoading = true;
      console.error(action.error);
    });
    builder.addCase(updateCategory.pending, (state) => {
      state.isLoading = true;
      state.isViewModalOpen = false;
    });
    builder.addCase(updateCategory.fulfilled, (state, action) => {
      state.isLoading = false;
      state.response = action.payload;
      state.isEditModalOpen = false;
    });
    builder.addCase(updateCategory.rejected, (state, action) => {
      state.isLoading = true;
      console.error(action.error);
    });
  },
});
export const { viewCategory, openDeleteModal, closeModal, editCategory } =
  categorySlice.actions;
export default categorySlice.reducer;
